"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _http_request = _interopRequireDefault(require("../../gateway/http_request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var BookmarksService = (applicationToken, sessionToken) => {
  var {
    buildHeader,
    get,
    post,
    deleteMethod
  } = (0, _http_request.default)(applicationToken, sessionToken);
  var listUserBookmarks = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (bookId, userId) {
      var headers = {};
      var path = "/booknotes/api/v1/bookmarks?book_id=".concat(bookId, "&user_id=").concat(userId);
      headers = buildHeader(headers);
      var response = yield get(path, null, headers);
      return response;
    });
    return function listUserBookmarks(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var createUserBookmark = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (payload) {
      var headers = {};
      var path = '/booknotes/api/v1/bookmarks';
      headers = buildHeader(headers);
      var response = yield post(path, payload, headers);
      return response;
    });
    return function createUserBookmark(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var deleteUserBookmark = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (bookmarkId) {
      var headers = {};
      var path = "/booknotes/api/v1/bookmarks/".concat(bookmarkId);
      headers = buildHeader(headers);
      var response = yield deleteMethod(path, null, headers);
      return response;
    });
    return function deleteUserBookmark(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    listUserBookmarks,
    createUserBookmark,
    deleteUserBookmark
  };
};
var _default = exports.default = BookmarksService;